<script>
  import { required, numeric, requiredIf, between } from 'vuelidate/lib/validators'
  const secureKeys = [
    'Backspace',
    'Escape',
    'Enter',
    'ArrowUp',
    'ArrowLeft',
    'ArrowRight',
    'ArrowDown',
    ' ',
    'CapsLock',
    'Shift',
    'Meta',
    'Alt',
    'Control',
    'Tab',
  ];

  let familiar_structure = {
    familiars_name: '',
    familiars_relationship: '',
    familiars_age: ''
  };

  let card_structure = {
    card_name: ''
  };

  let serious_illness_structure = {
    relation: '',
    illness: ''
  }

  let familiar_medicine_structure = {
    name: '',
    patient: '',
    illness: '',
    amount: '',
    pay_by: ''
  };

  let familiar_therapy_structure = {
    patient: '',
    type: '',
    amount: '',
    amount_contribution: '',
  }

  let children_at_school_structure = {
    name: '',
    age: '',
    grade: '',
    //year: '',
    school: '',
    attends_school: '',
  };

  let car_structure = {
    brand: '',
    model: '',
    year: '',
  };

  let debts_structure = {
    name: '',
    amount: '',
    monthly_amount: '',
    seniority: '',
  };

  let community_structure = {
    community_name: '',
    community_amount: '',
  };

  export default {
    props: [
      'stepOne',
      'stepTwo',
      'stepThree',
      'stepFour',
      'stepFive',
      'stepSix',
      'step',
      'uploader',
    ],
    data() {
      let self = this,
          fullData = {
            active_step: self.$props.step,
            sending: false,
            editing: undefined,
          },
          stepOne = {},
          stepTwo = {},
          stepThree = {},
          stepFour = {},
          stepFive = {},
          stepSix = {},
          uploader = {
            uploader_options: {
              step: null,
              file: null,
              key: '',
              uploading: false
            }
          };

      // Step 1
      if(self.$props.stepOne != undefined) {
        stepOne = {
          family: self.$props.stepOne.family,
          general_information: {
            father: {
              name: self.$props.stepOne.general_information.father.name,
              last_name: self.$props.stepOne.general_information.father.last_name,
              mothers_last_name: self.$props.stepOne.general_information.father.mothers_last_name,
              age: self.$props.stepOne.general_information.father.age,
              civil_state: self.$props.stepOne.general_information.father.civil_state,
              community: self.$props.stepOne.general_information.father.community,
              street_address: self.$props.stepOne.general_information.father.street_address,
              suburb: self.$props.stepOne.general_information.father.suburb,
              town: self.$props.stepOne.general_information.father.town,
              tel: self.$props.stepOne.general_information.father.tel,
              email: self.$props.stepOne.general_information.father.email,
            },
            mother: {
              name: self.$props.stepOne.general_information.mother.name,
              last_name: self.$props.stepOne.general_information.mother.last_name,
              mothers_last_name: self.$props.stepOne.general_information.mother.mothers_last_name,
              age: self.$props.stepOne.general_information.mother.age,
              civil_state: self.$props.stepOne.general_information.mother.civil_state,
              community: self.$props.stepOne.general_information.mother.community,
              street_address: self.$props.stepOne.general_information.mother.street_address,
              suburb: self.$props.stepOne.general_information.mother.suburb,
              town: self.$props.stepOne.general_information.mother.town,
              tel: self.$props.stepOne.general_information.mother.tel,
              email: self.$props.stepOne.general_information.mother.email,
            },
          },
          number_of_children: self.$props.stepOne.number_of_children,
          number_of_dependents: self.$props.stepOne.number_of_dependents,
          children_live_with: self.$props.stepOne.children_live_with,
          children_live_with_other: self.$props.stepOne.children_live_with_other,
          covers_family_expenses: self.$props.stepOne.covers_family_expenses,
        };
      } else {
        stepOne = {
          family: '',
          general_information: {
            father: {
              name: '',
              last_name: '',
              mothers_last_name: '',
              age: '',
              civil_state: '',
              community: '',
              street_address: '',
              suburb: '',
              town: '',
              tel: '',
              email: '',
            },
            mother: {
              name: '',
              last_name: '',
              mothers_last_name: '',
              age: '',
              civil_state: '',
              community: '',
              street_address: '',
              suburb: '',
              town: '',
              tel: '',
              email: '',
            },
          },
          number_of_children: '',
          number_of_dependents: '',
          children_live_with: null,
          children_live_with_other: null,
          covers_family_expenses: null,
        };
      }
      // End Step 1
      // Step 2
      if(self.$props.stepTwo != undefined) {
        stepTwo = {
          house_type: self.$props.stepTwo.house_type,
          other_house_type: self.$props.stepTwo.other_house_type,
          house_monthly_cost: self.$props.stepTwo.house_monthly_cost,
          house_monthly_cost_contribution: self.$props.stepTwo.house_monthly_cost_contribution,
          house_monthly_rent: self.$props.stepTwo.house_monthly_rent,
          house_monthly_rent_contribution: self.$props.stepTwo.house_monthly_rent_contribution,
          house_monthly_expenses_file_rent_url: self.$props.stepTwo.house_monthly_expenses_file_rent_url,
          house_monthly_expenses_file_maintenance_url: self.$props.stepTwo.house_monthly_expenses_file_maintenance_url,
          house_monthly_expenses_file_propertytax_url: self.$props.stepTwo.house_monthly_expenses_file_propertytax_url,
          house_monthly_expenses_file_mortage_url: self.$props.stepTwo.house_monthly_expenses_file_mortage_url,
          house_monthly_expenses_file_others_url: self.$props.stepTwo.house_monthly_expenses_file_others_url,
          includes_maintenance: self.$props.stepTwo.includes_maintenance,
          house_monthly_maintenance: self.$props.stepTwo.house_monthly_maintenance,
          house_monthly_maintenance_contribution: self.$props.stepTwo.house_monthly_maintenance_contribution,
          mother_house_type: self.$props.stepTwo.mother_house_type,
          mother_other_house_type: self.$props.stepTwo.mother_other_house_type,
          mother_house_monthly_cost: self.$props.stepTwo.mother_house_monthly_cost,
          mother_house_monthly_cost_contribution: self.$props.stepTwo.mother_house_monthly_cost_contribution,
          mother_house_monthly_rent: self.$props.stepTwo.mother_house_monthly_rent,
          mother_house_monthly_rent_contribution: self.$props.stepTwo.mother_house_monthly_rent_contribution,
          mother_house_monthly_expenses_file_rent_url: self.$props.stepTwo.mother_house_monthly_expenses_file_rent_url,
          mother_house_monthly_expenses_file_maintenance_url: self.$props.stepTwo.mother_house_monthly_expenses_file_maintenance_url,
          mother_house_monthly_expenses_file_propertytax_url: self.$props.stepTwo.mother_house_monthly_expenses_file_propertytax_url,
          mother_house_monthly_expenses_file_mortage_url: self.$props.stepTwo.mother_house_monthly_expenses_file_mortage_url,
          mother_house_monthly_expenses_file_others_url: self.$props.stepTwo.mother_house_monthly_expenses_file_others_url,
          mother_includes_maintenance: self.$props.stepTwo.mother_includes_maintenance,
          mother_house_monthly_maintenance: self.$props.stepTwo.mother_house_monthly_maintenance,
          mother_house_monthly_maintenance_contribution: self.$props.stepTwo.mother_house_monthly_maintenance_contribution,
          has_common_areas: self.$props.stepTwo.has_common_areas,
          common_areas: self.$props.stepTwo.common_areas,
          rooms: self.$props.stepTwo.rooms,
          people_by_room: self.$props.stepTwo.people_by_room,
        };
      } else {
        stepTwo = {
          house_type: null,
          other_house_type: null,
          house_monthly_cost: '',
          house_monthly_cost_contribution: '',
          house_monthly_rent: '',
          house_monthly_rent_contribution: '',
          house_monthly_expenses_file_rent_url: '',
          house_monthly_expenses_file_maintenance_url: '',
          house_monthly_expenses_file_propertytax_url: '',
          house_monthly_expenses_file_mortage_url: '',
          house_monthly_expenses_file_others_url: '',
          includes_maintenance: null,
          house_monthly_maintenance: '',
          house_monthly_maintenance_contribution: '',
          mother_house_type: null,
          mother_other_house_type: null,
          mother_house_monthly_cost: '',
          mother_house_monthly_cost_contribution: '',
          mother_house_monthly_rent: '',
          mother_house_monthly_rent_contribution: '',
          mother_house_monthly_expenses_file_rent_url: '',
          mother_house_monthly_expenses_file_maintenance_url: '',
          mother_house_monthly_expenses_file_propertytax_url: '',
          mother_house_monthly_expenses_file_mortage_url: '',
          mother_house_monthly_expenses_file_others_url: '',
          mother_includes_maintenance: null,
          mother_house_monthly_maintenance: '',
          mother_house_monthly_maintenance_contribution: '',
          has_common_areas: null,
          common_areas: '',
          rooms: null,
          people_by_room: null,
        };
      }
      // End Step 2
      // Step 3
      if(self.$props.stepThree != undefined) {
        stepThree = {
          parents_job: self.$props.stepThree.parents_job,
          parents_not_work_reason: self.$props.stepThree.parents_not_work_reason,
          parents_job_information: {
            father: {
              actual_job: self.$props.stepThree.parents_job_information.father.actual_job,
              education: self.$props.stepThree.parents_job_information.father.education,
              total_amount: self.$props.stepThree.parents_job_information.father.total_amount,
              another_income: self.$props.stepThree.parents_job_information.father.another_income,
              another_income_name: self.$props.stepThree.parents_job_information.father.another_income_name,
              another_income_amount: self.$props.stepThree.parents_job_information.father.another_income_amount,
            },
            mother: {
              actual_job: self.$props.stepThree.parents_job_information.mother.actual_job,
              education: self.$props.stepThree.parents_job_information.mother.education,
              total_amount: self.$props.stepThree.parents_job_information.mother.total_amount,
              another_income: self.$props.stepThree.parents_job_information.mother.another_income,
              another_income_name: self.$props.stepThree.parents_job_information.mother.another_income_name,
              another_income_amount: self.$props.stepThree.parents_job_information.mother.another_income_amount,
            },
          },
          parents_job_father_incomes_file_url: self.$props.stepThree.parents_job_father_incomes_file_url,
          parents_job_mother_incomes_file_url: self.$props.stepThree.parents_job_mother_incomes_file_url,
          children_working: self.$props.stepThree.children_working,
          children_input_amount: self.$props.stepThree.children_input_amount,
          has_community_support: self.$props.stepThree.has_community_support,
          community_support: (self.$props.stepThree.community_support != undefined) ? self.$props.stepThree.community_support : [],
          first_community_support: (self.$props.stepThree.community_support != undefined) ? (self.$props.stepThree.community_support.length > 0) : false,
        };
      } else {
        stepThree = {
          parents_job: null,
          parents_not_work_reason: '',
          parents_job_information: {
            father: {
              actual_job: '',
              education: '',
              total_amount: '',
              another_income: null,
              another_income_name: '',
              another_income_amount: '',
            },
            mother: {
              actual_job: '',
              education: '',
              total_amount: '',
              another_income: null,
              another_income_name: '',
              another_income_amount: '',
            },
          },
          parents_job_father_incomes_file_url: '',
          parents_job_mother_incomes_file_url: '',
          children_working: null,
          children_input_amount: '',
          has_community_support: '',
          community_support: [],
          first_community_support: false,
        };
      }
      // End Step 3
      // Step 4
      if(self.$props.stepFour != undefined) {
        stepFour = {
          ill_relatives: (self.$props.stepFour.ill_relatives != undefined) ? self.$props.stepFour.ill_relatives : [],
          medicines: (self.$props.stepFour.medicines != undefined) ? self.$props.stepFour.medicines : [],
          therapies: (self.$props.stepFour.therapies != undefined) ? self.$props.stepFour.therapies : [],
          services: {
            water: self.$props.stepFour.services.water,
            light: self.$props.stepFour.services.light,
            gas: self.$props.stepFour.services.gas,
            food: self.$props.stepFour.services.food,
            service: self.$props.stepFour.services.service,
            spreading: self.$props.stepFour.services.spreading,
            holydays: self.$props.stepFour.services.holydays,
            araja: self.$props.stepFour.services.araja,
            phone: self.$props.stepFour.services.phone,
            gasoline: self.$props.stepFour.services.gasoline,
          },
          services_amount: {
            water: self.$props.stepFour.services_amount.water,
            light: self.$props.stepFour.services_amount.light,
            gas: self.$props.stepFour.services_amount.gas,
            food: self.$props.stepFour.services_amount.food,
            service: self.$props.stepFour.services_amount.service,
            spreading: self.$props.stepFour.services_amount.spreading,
            holydays: self.$props.stepFour.services_amount.holydays,
            araja: self.$props.stepFour.services_amount.araja,
            phone: self.$props.stepFour.services_amount.phone,
            gasoline: self.$props.stepFour.services_amount.gasoline,
          },
          mother_services: (self.$props.stepFour.mother_services != null) ? {
            water: self.$props.stepFour.mother_services.water,
            light: self.$props.stepFour.mother_services.light,
            gas: self.$props.stepFour.mother_services.gas,
            food: self.$props.stepFour.mother_services.food,
            service: self.$props.stepFour.mother_services.service,
            spreading: self.$props.stepFour.mother_services.spreading,
            holydays: self.$props.stepFour.mother_services.holydays,
            araja: self.$props.stepFour.mother_services.araja,
            phone: self.$props.stepFour.mother_services.phone,
            gasoline: self.$props.stepFour.mother_services.gasoline,
          } :
          {
            water: '',
            light: '',
            gas: '',
            food: '',
            service: '',
            spreading: '',
            holydays: '',
            araja: '',
            phone: '',
            gasoline: '',
          },
          mother_services_amount: (self.$props.stepFour.mother_services != null) ? {
            water: self.$props.stepFour.mother_services_amount.water,
            light: self.$props.stepFour.mother_services_amount.light,
            gas: self.$props.stepFour.mother_services_amount.gas,
            food: self.$props.stepFour.mother_services_amount.food,
            service: self.$props.stepFour.mother_services_amount.service,
            spreading: self.$props.stepFour.mother_services_amount.spreading,
            holydays: self.$props.stepFour.mother_services_amount.holydays,
            araja: self.$props.stepFour.mother_services_amount.araja,
            phone: self.$props.stepFour.mother_services_amount.phone,
            gasoline: self.$props.stepFour.mother_services_amount.gasoline,
          } :
          {
            water: '',
            light: '',
            gas: '',
            food: '',
            service: '',
            spreading: '',
            holydays: '',
            araja: '',
            phone: '',
            gasoline: '',
          },
          owed: self.$props.stepFour.owed,
          debts: (self.$props.stepFour.debts != null) ? self.$props.stepFour.debts : [],
          debts_statement_files: self.$props.stepFour.debts_statement_files,
          has_card: self.$props.stepFour.has_card,
          credit_cards: (self.$props.stepFour.credit_cards != undefined) ? self.$props.stepFour.credit_cards : [],
          credit_cards_statement_files: (self.$props.stepFour.credit_cards_statement_files != undefined) ? self.$props.stepFour.credit_cards_statement_files : [],
          has_health_insurance: self.$props.stepFour.has_health_insurance,
          medical_insurance: {
            insurance: self.$props.stepFour.medical_insurance.insurance,
            payment: self.$props.stepFour.medical_insurance.payment,
            pay_by: self.$props.stepFour.medical_insurance.pay_by
          },
          serious_illness_familiar: self.$props.stepFour.serious_illness_familiar,
          familiar_take_medicine: self.$props.stepFour.familiar_take_medicine,
          familiar_take_therapy: self.$props.stepFour.familiar_take_therapy,
          first_card: (self.$props.stepFour.credit_cards != undefined) ? (self.$props.stepFour.credit_cards.length > 0) : false,
          first_illness_familiar: (self.$props.stepFour.ill_relatives != undefined) ? (self.$props.stepFour.ill_relatives.length > 0) : false,
          first_medicine_familiar: (self.$props.stepFour.medicines != undefined) ? (self.$props.stepFour.medicines.length > 0) : false,
          first_therapy_familiar: (self.$props.stepFour.therapies != undefined) ? (self.$props.stepFour.therapies.length > 0) : false,
          first_debt: (self.$props.stepFour.debts != undefined) ? (self.$props.stepFour.debts.length > 0) : false,
          services_fees_water_file_url: self.$props.stepFour.services_fees_water_file_url,
          services_fees_light_file_url: self.$props.stepFour.services_fees_light_file_url,
          services_fees_gas_file_url: self.$props.stepFour.services_fees_gas_file_url,
          services_fees_araja_file_url: self.$props.stepFour.services_fees_araja_file_url,
          services_fees_phone_file_url: self.$props.stepFour.services_fees_phone_file_url,
          mother_services_fees_water_file_url: self.$props.stepFour.mother_services_fees_water_file_url,
          mother_services_fees_light_file_url: self.$props.stepFour.mother_services_fees_light_file_url,
          mother_services_fees_gas_file_url: self.$props.stepFour.mother_services_fees_gas_file_url,
          mother_services_fees_araja_file_url: self.$props.stepFour.mother_services_fees_araja_file_url,
          mother_services_fees_phone_file_url: self.$props.stepFour.mother_services_fees_phone_file_url,
          credit_bureau_file_url: self.$props.stepFour.credit_bureau_file_url,
          mother_credit_bureau_file_url: self.$props.stepFour.mother_credit_bureau_file_url,
          i94_file_url: self.$props.stepFour.i94_file_url,
        };
      } else {
        stepFour = {
          credit_cards: [],
          ill_relatives: [],
          medicines: [],
          therapies: [],
          services: {
            water: '',
            light: '',
            gas: '',
            food: '',
            service: '',
            spreading: '',
            holydays: '',
            araja: '',
            phone: '',
            gasoline: '',
          },
          services_amount: {
            water: '',
            light: '',
            gas: '',
            food: '',
            service: '',
            spreading: '',
            holydays: '',
            araja: '',
            phone: '',
            gasoline: '',
          },
          mother_services: {
            water: '',
            light: '',
            gas: '',
            food: '',
            service: '',
            spreading: '',
            holydays: '',
            araja: '',
            phone: '',
            gasoline: '',
          },
          mother_services_amount: {
            water: '',
            light: '',
            gas: '',
            food: '',
            service: '',
            spreading: '',
            holydays: '',
            araja: '',
            phone: '',
            gasoline: '',
          },
          owed: null,
          debts: [],
          debts_statement_files: [],
          has_card: '',
          credit_cards_statement_files: [],
          has_health_insurance: '',
          medical_insurance: {
            insurance: '',
            payment: '',
            pay_by: ''
          },
          serious_illness_familiar: null,
          familiar_take_medicine: null,
          familiar_take_therapy: null,
          first_card: false,
          first_illness_familiar: false,
          first_medicine_familiar: false,
          first_therapy_familiar: false,
          first_debt: false,
          services_fees_water_file_url: '',
          services_fees_light_file_url: '',
          services_fees_gas_file_url: '',
          services_fees_araja_file_url: '',
          services_fees_phone_file_url: '',
          mother_services_fees_water_file_url: '',
          mother_services_fees_light_file_url: '',
          mother_services_fees_gas_file_url: '',
          mother_services_fees_araja_file_url: '',
          mother_services_fees_phone_file_url: '',
          credit_bureau_file_url: '',
          mother_credit_bureau_file_url: '',
          i94_file_url: [],
        };
      }
      // End Step 4
      // Step 5
      if(self.$props.stepFive != undefined) {
        let newChildren = [],
            scholarship_max = 0;
        if(self.$props.stepFive.children_at_school !== undefined) {
           self.$props.stepFive.children_at_school.forEach(function(child) {
            if(child.attends_school === undefined) {
              child.attends_school = '';
            } else {
              scholarship_max += 1;
            }
            newChildren.push(child);
          });
        }

        stepFive = {
          children_at_school_qty: self.$props.stepFive.children_at_school_qty,
          first_children_at_school: (self.$props.stepFive.children_at_school != undefined) ? (self.$props.stepFive.children_at_school.length > 0) : false,
          children_at_school: newChildren,
          children_for_scholarship: (self.$props.stepFive.children_for_scholarship != undefined) ? self.$props.stepFive.children_for_scholarship : 0,
          children_for_scholarship_max: scholarship_max,
          school_payment_amount: self.$props.stepFive.school_payment_amount,
          school_payment_amount_contribution: self.$props.stepFive.school_payment_amount_contribution,
          school_expenses: {
            workshop: self.$props.stepFive.school_expenses.workshop,
            afternoon_classes: self.$props.stepFive.school_expenses.afternoon_classes,
            afternoon_classes_list: self.$props.stepFive.school_expenses.afternoon_classes_list,
            cdi: self.$props.stepFive.school_expenses.cdi,
            cdi_associated_number: self.$props.stepFive.school_expenses.cdi_associated_number,
          },
          school_expenses_total_amount: {
            workshop: self.$props.stepFive.school_expenses_total_amount.workshop,
            afternoon_classes: self.$props.stepFive.school_expenses_total_amount.afternoon_classes,
            cdi: self.$props.stepFive.school_expenses_total_amount.cdi,
          },
        };
      } else {
        stepFive = {
          children_at_school_qty: null,
          first_children_at_school: false,
          children_at_school: [],
          children_for_scholarship: 0,
          children_for_scholarship_max: 0,
          school_payment_amount: '',
          school_payment_amount_contribution: '',
          school_expenses: {
            workshop: null,
            afternoon_classes: null,
            afternoon_classes_list: null,
            cdi: null,
            cdi_associated_number: null,
          },
          school_expenses_total_amount: {
            workshop: '',
            afternoon_classes: '',
            cdi: '',
          },
        };
      }
      // End Step 5
      // Step 6
      if(self.$props.stepSix != undefined) {
        stepSix = {
          has_car: self.$props.stepSix.has_car,
          cars_qty: self.$props.stepSix.cars_qty,
          vehicle_information: (self.$props.stepSix.vehicle_information != undefined) ? self.$props.stepSix.vehicle_information : [],
          circulation_card_files: self.$props.stepSix.circulation_card_files,
          cars_paid: self.$props.stepSix.cars_paid,
          vehicle_total_due_amount: self.$props.stepSix.vehicle_total_due_amount,
          vehicle_monthly_total_amount: self.$props.stepSix.vehicle_monthly_total_amount,
          vehicle_due_contribution: self.$props.stepSix.vehicle_due_contribution,
          has_assurance: self.$props.stepSix.has_assurance,
          vehicle_insurance_amount: self.$props.stepSix.vehicle_insurance_amount,
          vehicle_insurance_amount_contribution: self.$props.stepSix.vehicle_insurance_amount_contribution,
          scholarship_amount_requested: self.$props.stepSix.scholarship_amount_requested,
          terms_accepted_by: self.$props.stepSix.terms_accepted_by,
          i_declare: self.$props.stepSix.i_declare,
        };
      } else {
        stepSix = {
          has_car: null,
          cars_qty: '',
          vehicle_information: [],
          circulation_card_files: [],
          cars_paid: null,
          vehicle_total_due_amount: '',
          vehicle_monthly_total_amount: '',
          vehicle_due_contribution: '',
          has_assurance: null,
          vehicle_insurance_amount: '',
          vehicle_insurance_amount_contribution: '',
          scholarship_amount_requested: '',
          terms_accepted_by: '',
          i_declare: '',
        };
      }
      // End Step 6

      fullData = _.merge(fullData, stepOne, stepTwo, stepThree, stepFour, stepFive, stepSix, uploader);

      return fullData;
    },
    validations() {
      let self = this;
      if(self.active_step == 1) {
        return {
          number_of_children: {
            required,
            numeric,
          },
          number_of_dependents: {
            required,
            numeric
          },
          children_live_with: {
            required
          },
          children_live_with_other: {
            requiredIf: requiredIf(function() {
              return this.children_live_with == 'other'
            }),
          },
          covers_family_expenses: {
            requiredIf: requiredIf(function() {
              return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
            }),
          },
        }
      } else if(self.active_step == 2) {
        let step2Validations = {
          house_type: {
            required
          },
          other_house_type: {
            requiredIf: requiredIf(function() {
              return self.house_type == 'other'
            })
          },
          house_monthly_cost: {
            requiredIf: requiredIf(function() {
              return self.house_type == 'own'
            }),
            numeric,
          },
          house_monthly_rent: {
            requiredIf: requiredIf(function() {
              return self.house_type == 'rent' || self.house_type == 'mortage'
            }),
            numeric,
          },
          includes_maintenance: {
            requiredIf: requiredIf(function() {
              return self.house_type == 'rent'
            }),
          },
          house_monthly_maintenance:{
            requiredIf: requiredIf(function() {
              return (self.house_type == 'rent' && self.includes_maintenance == 'no') || self.house_type == 'mortage' || self.house_type == 'own'
            }),
            numeric
          },
          house_monthly_expenses_file_maintenance_url:{
            /*requiredIf: requiredIf(function() {
              return (self.house_type == 'rent' && self.includes_maintenance == 'no') || self.house_type == 'mortage' || self.house_type == 'own'
            })*/
          },
          mother_house_type: {
            requiredIf: requiredIf(function() {
              return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
            }),
          },
          mother_other_house_type: {
            requiredIf: requiredIf(function() {
              return self.mother_house_type == 'other'
            })
          },
          mother_house_monthly_cost: {
            requiredIf: requiredIf(function() {
              return self.mother_house_type == 'own'
            }),
            numeric,
          },
          mother_house_monthly_rent: {
            requiredIf: requiredIf(function() {
              return self.mother_house_type == 'rent' || self.mother_house_type == 'mortage'
            }),
            numeric,
          },
          mother_includes_maintenance: {
            requiredIf: requiredIf(function() {
              return self.mother_house_type == 'rent'
            }),
          },
          mother_house_monthly_maintenance:{
            requiredIf: requiredIf(function() {
              return (self.mother_house_type == 'rent' && self.mother_includes_maintenance == 'no') || self.mother_house_type == 'mortage' || self.mother_house_type == 'own'
            }),
            numeric
          },
          mother_house_monthly_expenses_file_maintenance_url:{
            /*requiredIf: requiredIf(function() {
              return (self.mother_house_type == 'rent' && self.mother_includes_maintenance == 'no') || self.mother_house_type == 'mortage' || self.mother_house_type == 'own'
            })*/
          },
          has_common_areas: {
            required
          },
          common_areas: {
            requiredIf: requiredIf(function() {
              return self.has_common_areas == 'yes'
            })
          },
          rooms: {
            required
          },
          people_by_room: {
            required
          }
        };

        return step2Validations;
      } else if(self.active_step == 3) {
        let step3Validation = {
          children_working: {
            required
          },
          parents_job: {
            required
          },
          parents_job_information: {
            father: {
              actual_job: {
                required
              },
              total_amount: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.father.actual_job != 'unemployee'
                }),
                numeric
              },
              another_income: {
                required
              },
              another_income_name: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.father.another_income == 'yes'
                }),
              },
              another_income_amount: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.father.another_income == 'yes'
                }),
                numeric
              }
            },
            mother: {
              actual_job: {
                required
              },
              total_amount: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.mother.actual_job != 'unemployee'
                }),
                numeric
              },
              another_income: {
                required
              },
              another_income_name: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.mother.another_income == 'yes'
                }),
              },
              another_income_amount: {
                requiredIf: requiredIf(function() {
                  return self.parents_job_information.mother.another_income == 'yes'
                }),
                numeric
              }
            }
          },
          has_community_support: {
            required
          },
          community_support: {
            $each: {
              community_name: {
                requiredIf: requiredIf(function() {
                  return self.has_community_support == 'yes';
                })
              },
              community_amount: {
                requiredIf: requiredIf(function() {
                  return self.has_community_support == 'yes';
                }),
                numeric
              },
            }
          },
        };

        if(self.parents_job == 'no') {
          step3Validation = $.extend(step3Validation, {parents_not_work_reason: {
            required
          }});
        }

        if(self.children_working == 'yes') {
          step3Validation = $.extend(step3Validation, {children_input_amount: {
            required,
            numeric,
          }});
        }

        return step3Validation;
      } else if(self.active_step == 4) {
        let step4Validation = {
          services: {
            water: {
              required
            },
            light: {
              required
            },
            gas: {
              required
            },
            food: {
              required
            },
            service: {
              required
            },
            spreading: {
              required
            },
            holydays: {
              required
            },
            araja: {
              required
            },
            phone: {
              required
            },
            gasoline: {
              required
            }
          },
          services_amount: {
            water: {
              requiredIf: requiredIf(function() {
                return self.services.water == 'yes';
              }),
              numeric,
            },
            light: {
              requiredIf: requiredIf(function() {
                return self.services.light == 'yes';
              }),
              numeric,
            },
            gas: {
              requiredIf: requiredIf(function() {
                return self.services.gas == 'yes';
              }),
              numeric,
            },
            food: {
              requiredIf: requiredIf(function() {
                return self.services.food == 'yes';
              }),
              numeric,
            },
            service: {
              requiredIf: requiredIf(function() {
                return self.services.service == 'yes';
              }),
              numeric,
            },
            spreading: {
              requiredIf: requiredIf(function() {
                return self.services.spreading == 'yes';
              }),
              numeric,
            },
            holydays: {
              requiredIf: requiredIf(function() {
                return self.services.holydays == 'yes';
              }),
              numeric,
            },
            araja: {
              requiredIf: requiredIf(function() {
                return self.services.araja == 'yes';
              }),
              numeric,
            },
            phone: {
              requiredIf: requiredIf(function() {
                return self.services.phone == 'yes';
              }),
              numeric,
            },
            gasoline: {
              requiredIf: requiredIf(function() {
                return self.services.gasoline == 'yes';
              }),
              numeric,
            }
          },
          mother_services: {
            water: {
              requiredIf: requiredIf(function() {
                return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
              }),
            },
            light: {
              requiredIf: requiredIf(function() {
                return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
              }),
            },
            gas: {
              requiredIf: requiredIf(function() {
                return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
              }),
            },
            food: {
              requiredIf: requiredIf(function() {
                return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
              }),
            },
            service: {
              requiredIf: requiredIf(function() {
                return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
              }),
            },
            spreading: {
              requiredIf: requiredIf(function() {
                return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
              }),
            },
            holydays: {
              requiredIf: requiredIf(function() {
                return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
              }),
            },
            araja: {
              requiredIf: requiredIf(function() {
                return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
              }),
            },
            phone: {
              requiredIf: requiredIf(function() {
                return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
              }),
            },
            gasoline: {
              requiredIf: requiredIf(function() {
                return self.general_information.father.civil_state == 'divorced' || self.general_information.mother.civil_state == 'divorced'
              }),
            }
          },
          mother_services_amount: {
            water: {
              requiredIf: requiredIf(function() {
                return self.mother_services.water == 'yes';
              }),
              numeric,
            },
            light: {
              requiredIf: requiredIf(function() {
                return self.mother_services.light == 'yes';
              }),
              numeric,
            },
            gas: {
              requiredIf: requiredIf(function() {
                return self.mother_services.gas == 'yes';
              }),
              numeric,
            },
            food: {
              requiredIf: requiredIf(function() {
                return self.mother_services.food == 'yes';
              }),
              numeric,
            },
            service: {
              requiredIf: requiredIf(function() {
                return self.mother_services.service == 'yes';
              }),
              numeric,
            },
            spreading: {
              requiredIf: requiredIf(function() {
                return self.mother_services.spreading == 'yes';
              }),
              numeric,
            },
            holydays: {
              requiredIf: requiredIf(function() {
                return self.mother_services.holydays == 'yes';
              }),
              numeric,
            },
            araja: {
              requiredIf: requiredIf(function() {
                return self.mother_services.araja == 'yes';
              }),
              numeric,
            },
            phone: {
              requiredIf: requiredIf(function() {
                return self.mother_services.phone == 'yes';
              }),
              numeric,
            },
            gasoline: {
              requiredIf: requiredIf(function() {
                return self.mother_services.gasoline == 'yes';
              }),
              numeric,
            }
          },
          owed: {
            required
          },
          debts: {
            $each: {
              name: {
                requiredIf: requiredIf(function() {
                  return self.owed == 'yes';
                })
              },
              amount: {
                requiredIf: requiredIf(function() {
                  return self.owed == 'yes';
                }),
                numeric
              },
              monthly_amount: {
                requiredIf: requiredIf(function() {
                  return self.owed == 'yes';
                }),
                numeric
              },
              seniority: {
                requiredIf: requiredIf(function() {
                  return self.owed == 'yes';
                })
              },
            }
          },
          has_card: {
            required
          },
          credit_cards: {
            $each: {
              card_name: {
                requiredIf: requiredIf(function() {
                  return self.has_card == 'yes';
                })
              }
            }
          },
          has_health_insurance: {
            required
          },
          medical_insurance: {
            payment: {
              requiredIf: requiredIf(function() {
                return self.has_health_insurance == 'yes';
              }),
              numeric
            }
          },
          serious_illness_familiar: {
            required
          },
          ill_relatives: {
            $each: {
              relation: {
                requiredIf: requiredIf(function() {
                  return self.serious_illness_familiar == 'yes';
                })
              },
              illness: {
                requiredIf: requiredIf(function() {
                  return self.serious_illness_familiar == 'yes';
                })
              },
            }
          },
          familiar_take_medicine: {
            required
          },
          medicines: {
            $each: {
              name: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_medicine == 'yes';
                })
              },
              patient: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_medicine == 'yes';
                })
              },
              illness: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_medicine == 'yes';
                })
              },
              amount: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_medicine == 'yes';
                }),
                numeric
              },
              pay_by: {}
            }
          },
          familiar_take_therapy: {
            required
          },
          therapies: {
            $each: {
              patient: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_therapy == 'yes';
                })
              },
              type: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_therapy == 'yes';
                })
              },
              amount: {
                requiredIf: requiredIf(function() {
                  return self.familiar_take_therapy == 'yes';
                }),
                numeric
              },
              amount_contribution: {},
            }
          },
          credit_bureau_file_url: {},
          mother_credit_bureau_file_url: {},
          i94_file_url: {}
        };

        return step4Validation;
      } else if(self.active_step == 5) {
        let step5Validation = {
          children_at_school_qty: {
            required
          },
          children_at_school: {
            $each: {
              name: {
                requiredIf: requiredIf(function() {
                  return self.children_at_school_qty > 0;
                })
              },
              age: {
                requiredIf: requiredIf(function() {
                  return self.children_at_school_qty > 0;
                }),
                numeric
              },
              grade: {
                requiredIf: requiredIf(function() {
                  return self.children_at_school_qty > 0;
                })
              },
              /*year: {
                requiredIf: requiredIf(function() {
                  return self.children_at_school_qty > 0;
                })
              },*/
              attends_school: {
                requiredIf: requiredIf(function() {
                  return self.children_at_school_qty > 0;
                })
              },
              school: {
                requiredIf: requiredIf(function() {
                  return this.attends_school == 'no';
                })
              }
            }
          },
          children_for_scholarship: {
            requiredIf: requiredIf(function() {
              return self.children_for_scholarship_max > 0;
            }),
          },
          school_payment_amount: {
            requiredIf: requiredIf(function() {
              return self.children_at_school_qty > 0;
            }),
            numeric,
          },
          school_expenses: {
            workshop: {
              required
            },
            afternoon_classes: {
              required
            },
            afternoon_classes_list: {
              requiredIf: requiredIf(function() {
                return self.school_expenses.afternoon_classes == 'yes';
              })
            },
            cdi: {
              required
            },
            cdi_associated_number: {
              requiredIf: requiredIf(function() {
                return self.school_expenses.cdi == 'yes';
              })
            },
          },
          school_expenses_total_amount: {
            workshop: {
              requiredIf: requiredIf(function() {
                return self.school_expenses.workshop == 'yes';
              }),
              numeric
            },
            afternoon_classes: {
              requiredIf: requiredIf(function() {
                return self.school_expenses.afternoon_classes == 'yes';
              }),
              numeric
            },
            cdi: {
              requiredIf: requiredIf(function() {
                return self.school_expenses.cdi == 'yes';
              }),
              numeric
            },
          },
        };

        return step5Validation;
      } else if(self.active_step == 6) {
        let step6Validation = {
          has_car: {
            required
          },
          cars_qty: {
            requiredIf: requiredIf(function() {
              return self.has_car == 'yes';
            }),
            numeric
          },
          vehicle_information: {
            $each: {
              brand: {
                requiredIf: requiredIf(function() {
                  return self.cars_qty > 0 && self.has_car == 'yes';
                })
              },
              model: {
                requiredIf: requiredIf(function() {
                  return self.cars_qty > 0 && self.has_car == 'yes';
                })
              },
              year: {
                requiredIf: requiredIf(function() {
                  return self.cars_qty > 0 && self.has_car == 'yes';
                })
              },
            }
          },
          cars_paid: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.has_car == 'yes';
            })
          },
          vehicle_total_due_amount: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.cars_paid == 'no' && self.has_car == 'yes';
            }),
            numeric
          },
          vehicle_monthly_total_amount: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.cars_paid == 'no' && self.has_car == 'yes';
            }),
            numeric
          },
          has_assurance: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.has_car == 'yes';
            })
          },
          vehicle_insurance_amount: {
            requiredIf: requiredIf(function() {
              return self.cars_qty > 0 && self.has_assurance == 'yes' && self.has_car == 'yes';
            }),
            numeric
          },
          scholarship_amount_requested: {
            required,
            numeric,
            between: between(0,100)
          },
          terms_accepted_by: {
            required
          },
          i_declare: {
            required
          }
        };

        return step6Validation;
      }
    },
    watch: {
      cars_qty: function(val) {
        this.setCars(val);
      },
      editing: function(val) {
        if(this.active_step == 7) {
          // this.refreshPage();
        }
      }
    },
    methods: {
      call_axios: function(url, data) {
        let self = this,
            errorsText = '<ul>',
            errorsContainer = document.querySelector('.error-message--server');

        axios.post(url, {
          data: data
        })
        .then(function(response) {
          if(response.status == 200) {
            errorsContainer.innerHTML = '';
            self.active_step = self.active_step + 1;
          }
          self.sending = false;
        })
        .catch(function(error) {
          self.sending = false;
          for( let key in error.response.data.errors) {
            errorsText += '<li>' + error.response.data.errors[key][0] + '</li>';
          }
          errorsText += '</ul>';
          errorsContainer.innerHTML = errorsText;
          errorsContainer.classList.add('error-message--show');
        });
      },

      send_step_1: function() {
        let self        = this,
            arrayStep1  = {},
            step1URL    = document.querySelector('#step1_url').value,
            family_unique = document.querySelector('#family_unique').value;

        arrayStep1.family                   = family_unique;
        arrayStep1.general_information      = self.general_information;
        arrayStep1.children_live_with       = self.children_live_with;
        arrayStep1.children_live_with_other = self.children_live_with_other;
        arrayStep1.number_of_children       = self.number_of_children;
        arrayStep1.number_of_dependents     = self.number_of_dependents;
        arrayStep1.covers_family_expenses   = self.covers_family_expenses;
        arrayStep1.step                     = self.active_step;

        this.call_axios(step1URL, arrayStep1);
      },

      send_step_2: function() {
        let self        = this,
            arrayStep2  = {},
            step2URL    = document.querySelector('#step2_url').value;
        arrayStep2.house_type                                         = self.house_type;
        arrayStep2.other_house_type                                   = self.other_house_type;
        arrayStep2.house_monthly_cost                                 = self.house_monthly_cost;
        arrayStep2.house_monthly_cost_contribution                    = self.house_monthly_cost_contribution;
        arrayStep2.house_monthly_rent                                 = self.house_monthly_rent;
        arrayStep2.house_monthly_rent_contribution                    = self.house_monthly_rent_contribution;
        arrayStep2.house_monthly_expenses_file_rent_url               = self.house_monthly_expenses_file_rent_url;
        arrayStep2.house_monthly_expenses_file_mortage_url            = self.house_monthly_expenses_file_mortage_url;
        arrayStep2.house_monthly_expenses_file_maintenance_url        = self.house_monthly_expenses_file_maintenance_url;
        arrayStep2.house_monthly_expenses_file_propertytax_url        = self.house_monthly_expenses_file_propertytax_url;
        arrayStep2.house_monthly_expenses_file_others_url             = self.house_monthly_expenses_file_others_url;
        arrayStep2.includes_maintenance                               = self.includes_maintenance;
        arrayStep2.house_monthly_maintenance                          = self.house_monthly_maintenance;
        arrayStep2.house_monthly_maintenance_contribution             = self.house_monthly_maintenance_contribution;
        arrayStep2.mother_house_type                                  = self.mother_house_type;
        arrayStep2.mother_other_house_type                            = self.mother_other_house_type;
        arrayStep2.mother_house_monthly_cost                          = self.mother_house_monthly_cost;
        arrayStep2.mother_house_monthly_cost_contribution             = self.mother_house_monthly_cost_contribution;
        arrayStep2.mother_house_monthly_rent                          = self.mother_house_monthly_rent;
        arrayStep2.mother_house_monthly_rent_contribution             = self.mother_house_monthly_rent_contribution;
        arrayStep2.mother_house_monthly_expenses_file_rent_url        = self.mother_house_monthly_expenses_file_rent_url;
        arrayStep2.mother_house_monthly_expenses_file_mortage_url     = self.mother_house_monthly_expenses_file_mortage_url;
        arrayStep2.mother_house_monthly_expenses_file_maintenance_url = self.mother_house_monthly_expenses_file_maintenance_url;
        arrayStep2.mother_house_monthly_expenses_file_propertytax_url = self.mother_house_monthly_expenses_file_propertytax_url;
        arrayStep2.mother_house_monthly_expenses_file_others_url      = self.mother_house_monthly_expenses_file_others_url;
        arrayStep2.mother_includes_maintenance                        = self.mother_includes_maintenance;
        arrayStep2.mother_house_monthly_maintenance                   = self.mother_house_monthly_maintenance;
        arrayStep2.mother_house_monthly_maintenance_contribution      = self.mother_house_monthly_maintenance_contribution;
        arrayStep2.has_common_areas                                   = self.has_common_areas;
        arrayStep2.common_areas                                       = self.common_areas;
        arrayStep2.rooms                                              = self.rooms;
        arrayStep2.people_by_room                                     = self.people_by_room;
        arrayStep2.step                                               = self.active_step;

        this.call_axios(step2URL, arrayStep2);
      },

      send_step_3: function() {
        let self        = this,
            arrayStep3  = {},
            step3URL    = document.querySelector('#step3_url').value;

        arrayStep3.parents_job                          = self.parents_job;
        arrayStep3.parents_not_work_reason              = self.parents_not_work_reason;
        arrayStep3.parents_job_information              = self.parents_job_information;
        arrayStep3.children_working                     = self.children_working;
        arrayStep3.parents_job_father_incomes_file_url  = self.parents_job_father_incomes_file_url;
        arrayStep3.parents_job_mother_incomes_file_url  = self.parents_job_mother_incomes_file_url;
        arrayStep3.children_input_amount                = self.children_input_amount;
        arrayStep3.has_community_support                = self.has_community_support;
        arrayStep3.community_support                    = self.community_support;
        arrayStep3.step                                 = self.active_step;

        this.call_axios(step3URL, arrayStep3);
      },

      send_step_4: function() {
        let self        = this,
            arrayStep4  = {},
            step4URL    = document.querySelector('#step4_url').value;

        for(let key in self.services) {
          if(self.services[key] == 'no') {
            self.services_amount[key] = null;
          }
        }

        arrayStep4.services                         = self.services;
        arrayStep4.services_amount                  = self.services_amount;
        arrayStep4.owed                             = self.owed;
        arrayStep4.debts                            = self.debts;
        arrayStep4.debts_total_amount               = self.debts_total_amount;
        arrayStep4.has_card                         = self.has_card;
        arrayStep4.credit_cards                     = self.credit_cards;
        arrayStep4.has_health_insurance             = self.has_health_insurance;
        arrayStep4.medical_insurance                = self.medical_insurance;
        arrayStep4.serious_illness_familiar         = self.serious_illness_familiar;
        arrayStep4.ill_relatives                    = self.ill_relatives;
        arrayStep4.familiar_take_medicine           = self.familiar_take_medicine;
        arrayStep4.medicines                        = self.medicines;
        arrayStep4.familiar_take_therapy            = self.familiar_take_therapy;
        arrayStep4.therapies                        = self.therapies;
        arrayStep4.debts_statement_files            = self.debts_statement_files;
        arrayStep4.credit_cards_statement_files     = self.credit_cards_statement_files;
        arrayStep4.services_fees_water_file_url     = self.services_fees_water_file_url;
        arrayStep4.services_fees_light_file_url     = self.services_fees_light_file_url;
        arrayStep4.services_fees_gas_file_url       = self.services_fees_gas_file_url;
        arrayStep4.services_fees_araja_file_url     = self.services_fees_araja_file_url;
        arrayStep4.services_fees_phone_file_url     = self.services_fees_phone_file_url;
        arrayStep4.credit_bureau_file_url           = self.credit_bureau_file_url;
        arrayStep4.mother_credit_bureau_file_url    = self.mother_credit_bureau_file_url;
        arrayStep4.i94_file_url    = self.i94_file_url;
        for(let key in self.mother_services) {
          if(self.mother_services[key] == 'no') {
            self.mother_services_amount[key] = null;
          }
        }

        arrayStep4.services                                = self.services;
        arrayStep4.services_amount                         = self.services_amount;
        arrayStep4.mother_services                         = self.mother_services;
        arrayStep4.mother_services_amount                  = self.mother_services_amount;
        arrayStep4.owed                                    = self.owed;
        arrayStep4.debts                                   = self.debts;
        arrayStep4.debts_total_amount                      = self.debts_total_amount;
        arrayStep4.has_card                                = self.has_card;
        arrayStep4.credit_cards                            = self.credit_cards;
        arrayStep4.has_health_insurance                    = self.has_health_insurance;
        arrayStep4.medical_insurance                       = self.medical_insurance;
        arrayStep4.serious_illness_familiar                = self.serious_illness_familiar;
        arrayStep4.ill_relatives                           = self.ill_relatives;
        arrayStep4.familiar_take_medicine                  = self.familiar_take_medicine;
        arrayStep4.medicines                               = self.medicines;
        arrayStep4.familiar_take_therapy                   = self.familiar_take_therapy;
        arrayStep4.therapies                               = self.therapies;
        arrayStep4.debts_statement_files                   = self.debts_statement_files;
        arrayStep4.credit_cards_statement_files            = self.credit_cards_statement_files;
        arrayStep4.services_fees_water_file_url            = self.services_fees_water_file_url;
        arrayStep4.services_fees_light_file_url            = self.services_fees_light_file_url;
        arrayStep4.services_fees_gas_file_url              = self.services_fees_gas_file_url;
        arrayStep4.services_fees_araja_file_url            = self.services_fees_araja_file_url;
        arrayStep4.services_fees_phone_file_url            = self.services_fees_phone_file_url;
        arrayStep4.mother_services_fees_water_file_url     = self.mother_services_fees_water_file_url;
        arrayStep4.mother_services_fees_light_file_url     = self.mother_services_fees_light_file_url;
        arrayStep4.mother_services_fees_gas_file_url       = self.mother_services_fees_gas_file_url;
        arrayStep4.mother_services_fees_araja_file_url     = self.mother_services_fees_araja_file_url;
        arrayStep4.mother_services_fees_phone_file_url     = self.mother_services_fees_phone_file_url;
        arrayStep4.credit_bureau_file_url                  = self.credit_bureau_file_url;
        arrayStep4.step = self.active_step;

        this.call_axios(step4URL, arrayStep4);
      },

      send_step_5: function() {
        let self        = this,
            arrayStep5  = {},
            step5URL    = document.querySelector('#step5_url').value;

        arrayStep5.children_at_school_qty               = self.children_at_school_qty;
        arrayStep5.children_at_school                   = self.children_at_school;
        arrayStep5.children_for_scholarship             = self.children_for_scholarship;
        arrayStep5.school_payment_amount                = self.school_payment_amount;
        arrayStep5.school_payment_amount_contribution   = self.school_payment_amount_contribution;
        arrayStep5.school_expenses                      = self.school_expenses;

        for(let key in self.school_expenses) {
          if(self.school_expenses[key] == 'no') {
            self.school_expenses_total_amount[key] = null;
          }
        }

        arrayStep5.school_expenses_total_amount = self.school_expenses_total_amount;
        arrayStep5.step                         = self.active_step;

        this.call_axios(step5URL, arrayStep5);
      },

      send_step_6: function() {
        let self        = this,
            arrayStep6  = {},
            step6URL    = document.querySelector('#step6_url').value;

        arrayStep6.has_car                                = self.has_car;
        arrayStep6.cars_qty                               = self.cars_qty;
        arrayStep6.vehicle_information                    = self.vehicle_information;
        arrayStep6.circulation_card_files                 = self.circulation_card_files;
        arrayStep6.cars_paid                              = self.cars_paid;
        arrayStep6.vehicle_total_due_amount               = self.vehicle_total_due_amount;
        arrayStep6.vehicle_monthly_total_amount           = self.vehicle_monthly_total_amount;
        arrayStep6.vehicle_due_contribution               = self.vehicle_due_contribution;
        arrayStep6.has_assurance                          = self.has_assurance;
        arrayStep6.vehicle_insurance_amount               = self.vehicle_insurance_amount;
        arrayStep6.vehicle_insurance_amount_contribution  = self.vehicle_insurance_amount_contribution;
        arrayStep6.scholarship_amount_requested           = self.scholarship_amount_requested;
        arrayStep6.terms_accepted_by                      = self.terms_accepted_by;
        arrayStep6.i_declare                              = (self.i_declare == 1) ? 1 : 0;
        arrayStep6.step                                   = self.active_step;

        this.call_axios(step6URL, arrayStep6);
      },

      validateAndAdvance() {
        let self = this;
        let activeStep = this.active_step;

        self.sending = true;

        let $container = document.querySelector('.step-' + activeStep);
        let $inputs = $container.querySelectorAll('.validation-item');

        $inputs.forEach(function($input) {
          self.$v[$input.getAttribute('vue-bind')].$touch();
        });

        if(!self.$v.$error && !self.$v.$invalid) {
          switch(self.active_step) {
            case 1:
              self.send_step_1();
              break;
            case 2:
              self.send_step_2();
              break;
            case 3:
              self.send_step_3();
              break;
            case 4:
              self.send_step_4();
              break;
            case 5:
              self.send_step_5();
              break;
            case 6:
              self.send_step_6();
              break;
          }
        } else {
          self.sending = false;
          console.log('Ocurrió un error');
        }
      },

      getBack() {
        this.active_step = this.active_step - 1;
      },

      setFlagToShowButtons($el, prop) {
        if($el.value != '') {
          this[prop] = true;
        } else {
          this[prop] = false;
        }
      },

      addFamiliar() {
        this.familiars.push(_.clone(familiar_structure));
      },

      addDebt() {
        this.debts.push(_.clone(debts_structure));
      },

      removeDebt() {
        if( this.debts.length > 1) {
          this.debts = this.debts.slice(0, this.debts.length - 1);
        }
      },

      initializeDebts() {
         if( this.debts.length == 0 && this.owed == 'yes' ) {
          this.debts.push(_.clone(debts_structure));
        }
      },

      addCard() {
        this.credit_cards.push(_.clone(card_structure));
      },

      removeCard() {
        if( this.credit_cards.length > 1) {
          this.credit_cards = this.credit_cards.slice(0, this.credit_cards.length - 1);
        }
      },

      initializeCards() {
        if( this.credit_cards.length == 0 && this.has_card == 'yes' ) {
          this.credit_cards.push(_.clone(card_structure));
        }
      },

      addSeriuosIllnessFamiliar() {
        this.ill_relatives.push(_.clone(serious_illness_structure));
      },

      removeSeriuosIllnessFamiliar() {
        if( this.ill_relatives.length > 1 ) {
          this.ill_relatives = this.ill_relatives.slice(0, this.ill_relatives.length - 1);
        }
      },

      initializeSeriousIllnessFamiliar() {
        if( this.ill_relatives.length == 0 && this.serious_illness_familiar == 'yes' ) {
          this.ill_relatives.push(_.clone(serious_illness_structure));
        }
      },

      addFamiliarTakeMedicine($target) {
        this.medicines.push(_.clone(familiar_medicine_structure));
      },

      removeFamiliarTakeMedicine() {
        if( this.medicines.length > 1 ) {
          this.medicines = this.medicines.slice(0, this.medicines.length - 1);
        }
      },

      initializeFamiliarTakeMedicine() {
        if( this.medicines.length == 0 && this.familiar_take_medicine == 'yes' ) {
          this.medicines.push(_.clone(familiar_medicine_structure));
        }
      },

      addFamiliarTakeTherapy($target) {
        this.therapies.push(_.clone(familiar_therapy_structure));
      },

      removeFamiliarTakeTherapy() {
        if( this.therapies.length > 1 ) {
          this.therapies = this.therapies.slice(0, this.therapies.length - 1);
        }
      },

      initializeFamiliarTakeTherapy() {
        if( this.therapies.length == 0 && this.familiar_take_therapy == 'yes' ) {
          this.therapies.push(_.clone(familiar_therapy_structure));
        }
      },

      addCommunitySupport() {
        this.community_support.push(_.clone(community_structure));
      },

      removeCommunitySupport() {
        if( this.community_support.length > 1) {
          this.community_support = this.community_support.slice(0, this.community_support.length - 1);
        }
      },

      initializeCommunitySupport() {
        if( this.community_support.length == 0 && this.has_community_support == 'yes') {
          this.community_support.push(_.clone(community_structure));
        }
      },

      setChildrenAtSchool() {
        let self = this;
        let tempArr = self.children_at_school;
        self.children_at_school = [];
        for(let i = 1; i <= self.children_at_school_qty; i++ ){
          if(tempArr[i]) {
            self.children_at_school.push(tempArr[i]);
          } else {
            self.children_at_school.push(_.clone(children_at_school_structure));
          }
        }
        self.updateChildrenForScholarship();
      },

      onlyNumeric($event) {
        if (secureKeys.indexOf($event.key) >= 0)
          return false;

        const validate = /^([0-9\.\,\-])$/.test($event.key);

        if (!validate)
          $event.preventDefault();
      },

      setCars(val) {
        let tempArr = this.vehicle_information;
        this.vehicle_information = [];
        for( let i = 1; i <= val; i++) {
          if(tempArr[i]) {
            this.vehicle_information.push(tempArr[i]);
          } else {
            this.vehicle_information.push(_.clone(car_structure));
          }
        }
      },

      setName(value) {
        this.father_name = value
        this.$v.father_name.$touch()
      },

      refreshPage() {
        let self = this;
        if(this.editing != false) {
          setTimeout(function() {
            window.location = self.editing;
          }, 5000);
        }
      },

      uploadButtonFile($event) {
        let event = $event;
        let self = this;
        event.preventDefault();
        if (event.target.dataset.id === undefined || event.target.dataset.id === null || this.uploader_options.file === null) {
          return;
        }
        const key = event.target.dataset.id;

        //ToDo if para tomar el url del boton actual

        self.uploader_options.key = event.target.dataset.id;
        self.uploader_options.uploading = true;

        let formData = new FormData();
        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        }
        formData.append('file', this.uploader_options.file);
        formData.append('field', this.uploader_options.key);

        axios.post('/uploader', formData, config)
          .then(function (response) {
            if (response.data.status === 200 && response.data.field && response.data.file_url) {
              const multiFileFields = [
                'credit_cards_statement_files', 
                'debts_statement_files', 
                'circulation_card_files', 
                'i94_file_url'
              ];
              if(multiFileFields.indexOf(key) >= 0) {
                self[key].push(response.data.file_url);
                return false;
              }
              self[key] = response.data.file_url;
            }
          })
          .then(function() {
            self.resetUploader(key);
            // --
            let $parent = self.findAncestor($event.target, '.form-group--uploader');
            $parent.classList.remove('form-group--uploader-alert');
          })
          .catch(function (error) {
            self.resetUploader(key);
            // --
            let $parent = self.findAncestor($event.target, '.form-group--uploader');

            $parent.querySelector('.alert-danger').innerHTML = `<i class="fa fa-times-circle"></i> ${error.response.data.message} <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>` || '';
          })
      },

      findAncestor (el, sel) {
        while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
        return el;
      },

      onFileSelected($event) {
        this.uploader_options.file = $event.target.files[0];
        // --
        let $parent = this.findAncestor($event.target, '.form-group--uploader');
        $parent.classList.add('form-group--uploader-alert');
        $parent.querySelector('.alert-danger').innerHTML = '';
      },

      resetUploader(id) {
        document.querySelector('#' + id).value = "";
        this.uploader_options = {
          step: null,
          file: null,
          key: '',
          uploading: false
        }
      },

      updateChildrenForScholarship() {
        let self = this;
        self.children_for_scholarship_max = 0;
        self.children_at_school.forEach(function(children) {
          self.children_for_scholarship_max += (children.attends_school == 'yes') ? 1 : 0;
        })
      }
    },
  };

</script>
